import React from 'react';
import { Card, Badge, Image, ListGroup, Modal, Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

function ModalCreateConfiguration({ show, onHide, selectedFlow, handleConfirmDelete, isLoadingButton }) {
    const { t } = useTranslation();
    
    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{t('Delete Flow - Are you sure?')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4 className="mb-2">{t('Notice')}</h4>
                <div className="text-danger mb-3">
                    <i className="fe fe-alert-triangle me-2"></i>
                    {t('This action cannot be undone!')}{' '}{t('Are you sure you want to delete this Flow?')}
                </div>
                
                <h4 className="mb-2">{t('What you will miss')}</h4>
                <div className="px-5 bg-light rounded p-4 mb-3">
                    <span className="text-muted fs-6">
                        {selectedFlow?.category &&
                            selectedFlow?.category === 'store' ? 'Marktplatz' :
                            selectedFlow?.category === 'shopsystem' ? 'Shop & Warenwirtschaft' :
                                selectedFlow?.category === 'other' ? 'Weitere Connectoren' :
                                    selectedFlow?.category
                        }
                    </span>
                    <h4 className="h5 mb-2 text-truncate-line-2 ">
                        {selectedFlow?.title ? selectedFlow?.title : ''}
                    </h4>
                    <span className="text-muted fs-6">
                        {selectedFlow?.description ? selectedFlow?.description : ''}
                    </span>
                    <ListGroup as="ul" bsPrefix="list-inline" className="mb-3 mt-2 text-muted fs-6">
                        {selectedFlow?.features && selectedFlow?.features.map((feature, index) => (
                            <ListGroup.Item as="li" bsPrefix="" key={index}>
                                <i className="fe fe-arrow-right"></i>
                                {feature}
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </div>
                <div className="pt-3">
                    <h4 className="mb-2">{t('Billing Summary')}</h4>
                    <div className="px-3 bg-light rounded p-3 mb-3">
                        <ListGroup variant="flush">
                            <ListGroup.Item className="d-flex justify-content-between align-items-center fs-6 text-muted">
                                <span>{t('Price')}</span>
                                <span>- {selectedFlow?.price ? `${selectedFlow.price} €` : t('N/A')}</span>
                            </ListGroup.Item>
                            {selectedFlow?.discount && selectedFlow.discount > 0 ? (
                                <>
                                <ListGroup.Item className="d-flex justify-content-between align-items-center fs-6 text-muted">
                                    <span>{t('Discount')}</span>
                                    <span>
                                        {selectedFlow?.discount && selectedFlow.discount > 0
                                            ? `- ${selectedFlow.discount} €`
                                            : '0 €'}
                                    </span>
                                </ListGroup.Item>
                                </>
                            ) : null }
                            <ListGroup.Item className="d-flex justify-content-between align-items-center fw-bold fs-6 text-muted">
                                <span>{t('Total')}{' '}{t('excl. VAT')}</span>
                                <span>
                                    - {selectedFlow?.price - selectedFlow?.discount > 0
                                        ? `${selectedFlow.price - selectedFlow.discount} € / ${t('Month')}`
                                        : t('for free')}
                                </span>
                            </ListGroup.Item>
                        </ListGroup>
                    </div>
                    <p className="text-muted small">
                        {t('By clicking Confirm Delete, you agree our terms and conditions. This costs will be removed from your current subscription price.')}{' '}
                        {t('On your next renewal you’ll be not longer charged for this Flow.')}
                    </p>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    {t('Cancel')}
                </Button>
                <Button variant="danger" onClick={handleConfirmDelete} disabled={isLoadingButton}>
                    {isLoadingButton ? (
                        <>
                            <Spinner animation="border" size="sm" className="me-2" />
                            {t('Confirm Delete')}
                        </>
                    ) : (
                            t('Confirm Delete')
                    )}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalCreateConfiguration;